import store from './store/index.js';

export default function auth({ next, to }) {
    if (!store.state.user) {
        return next({ name: 'LoginUser' });
    }
    
    // اگر کاربر login کرده و در صفحه login هست، به home redirect کن
    if (to.name === 'LoginUser') {
        return next({ name: 'IndexUser' });
    }
    
    return next();
}